import { prop, required } from "@rxweb/reactive-form-validators";
import { Resource } from "src/app/core/jsonapi/resource";
import { Client } from "../../clients/_types/client";
import { File } from "../../common/_types/file";
import { Case } from "./case";
import { CaseFileCategory } from "./case-file-category";
import { CaseService } from "./case-service";
import { Worker } from "../../workers/_types/worker";
import { User } from "../../users/_types/user";

export class CaseFile extends Resource {
    public override type = 'caseFiles';

    @prop()
    @required()
    public source: string = "User";

    @prop()
    @required()
    public caseId!: string;

    public case!: Case;

    @prop()
    public fileId!: string;

    public file!: File;

    @prop()
    public caseServiceId!: string;

    public caseService!: CaseService;

    @prop()
    public workerId!: string;

    public worker!: Worker;

    @prop()
    public clientId!: string;

    public client!: Client;

    @prop()
    public userId!: string;

    public user!: User;

    @prop()
    public notes!: string;

    @prop()
    public caseFileCategoryId!: string;

    public caseFileCategory!: CaseFileCategory;

    @prop()
    public showMobile: boolean = true;

    @prop()
    public showCaseTracking: boolean = true;

}

export class CaseServiceFilesPDFRequestDTO
{
    public caseId?: string;
    public templateId?: string | null;
    public num_images!: number;
    public landscape!: boolean;
    public logo!: boolean;
    public code!: boolean;
    public has_description_images!: boolean;
    public description!: string;
    public caseFilesIds: string[] = [];
    public caseFiles?: CaseServiceFilesRequestDTO[] = [];
}

export class CaseServiceFilesRequestDTO
{
    public caseFileId?: string;
    public index!: number;
}